import { ENewbuildingBrokerDIYActions, TNewbuildingBrokerDIYActions } from 'shared/actions/newbuildingBrokerDIY';
import { INewbuildingBrokerDIY } from 'shared/types/newbuildingBrokerDIY';

const initialState: INewbuildingBrokerDIY = {
  enabled: false,
  galleryBannerAnalyticsSent: false,
};

export const newbuildingBrokerDIYReducer = (
  state: INewbuildingBrokerDIY = initialState,
  action: TNewbuildingBrokerDIYActions,
): INewbuildingBrokerDIY => {
  switch (action.type) {
    case ENewbuildingBrokerDIYActions.SetEnabled:
      return {
        ...state,
        enabled: action.payload,
      };

    case ENewbuildingBrokerDIYActions.SetGalleryBannerAnalyticsSent:
      return {
        ...state,
        galleryBannerAnalyticsSent: true,
      };

    default:
      return state;
  }
};
